module.exports = __webpack_public_path__ + "img/03.cc211347.jpg";